import { Box } from '@mui/system';
import { CaretLeft } from '@phosphor-icons/react';
import { styled, Typography } from '@mui/material';

import { Link } from 'theSource/components/Link';

interface CustomActionStyledProps {
  $customActionAlignment?: string;
}

export const ActionsWrapperStyled = styled(Box)({
  alignItems: 'center',
  display: 'flex',
});

export const CustomActionStyled = styled(Box)<CustomActionStyledProps>(
  ({ $customActionAlignment }) => ({
    marginLeft: $customActionAlignment === 'right' ? 'auto' : '0',
  })
);

export const LinkStyled = styled(Link)(({ theme }) => ({
  padding: theme.spacing(1, 0),
})) as typeof Link;

export const CaretLeftStyled = styled(CaretLeft)(({ theme }) => ({
  fontSize: '1.6rem',
  color: theme.palette.primary.main,
}));

export const TitleStyled = styled('h2')({
  wordWrap: 'break-word',
}) as typeof Typography;
